module.exports = __webpack_public_path__ + "img/005-carnival-mask.f19b8b58.png";